export default __webpack_public_path__ + "static/media/smallStarTitle.decba5c7.svg";